// eslint-disable-next-line
export const UNAUTHENTICATED_URLS = [
    '/signup',
    '/login',
    '/passwordrecovery',
    '/setnewpassword',
    '/changedeviceowner',
    '/signupandchangedeviceowner'
];
